import React from 'react'
import PropTypes from 'prop-types'
import { NavLink } from 'react-router-dom'

// Routers
import {
  PATH_ECWT_LIST,
  PATH_MY_ACCOUNT,
  PATH_TICKET_SUPPORT,
} from 'routes/paths'

// Scss
import './Navbar.scss'

// WF: https://xd.adobe.com/view/42fc7d2d-fa51-4482-a24d-5bb475fcd003-17af/screen/5765cef8-1a95-4214-b6d0-f8d3d51e2efe/

export const Navbar = ({ items }) => {
  return (
    <div className="navbar-wrapper">
      {items.map((item) => (
        <NavLink
          key={item.id}
          to={item.path}
          className="navbar-link"
          activeClassName="active"
        >
          <div className="navbar-label">{item.label}</div>
          <div className="navbar-label-desktop">{item.labelDesktop}</div>
        </NavLink>
      ))}
    </div>
  )
}

Navbar.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      labelDesktop: PropTypes.string,
      path: PropTypes.string,
      id: PropTypes.string,
    })
  ),
}

Navbar.defaultProps = {
  items: [
    {
      label: 'Account & payments',
      labelDesktop: 'Account & payments',
      path: PATH_MY_ACCOUNT,
      id: 'page-my-account',
    },
    {
      label: 'eCWT',
      labelDesktop: 'e-Creditable Withholding Tax',
      path: PATH_ECWT_LIST,
      id: 'page-ecwt-list',
    },
    {
      label: 'Help & support',
      labelDesktop: 'Help & support',
      path: PATH_TICKET_SUPPORT,
      id: 'page-support',
    },
  ],
}

export default Navbar
